import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { CartPricingLineRequest } from './CartPricingLineRequest'
/**
* Class CartPricingRequest
*  Запрос расчёта корзины (§8.2).
*/
export class CartPricingRequest extends ActiveModel {

/**
  * promoCode
  * Промокод (приоритетнее сохранённого `CartPromoCode`).<br>
  */
  @ActiveField()
  promoCode?: null | string


  /**
  * deliveryPrice
  * Стоимость доставки для расчёта (опционально).<br>  */
  @ActiveField()
  deliveryPrice?: number


  /**
  * hasDelivery
  * Есть ли доставка в расчёте.<br>  */
  @ActiveField()
  hasDelivery?: boolean


/**
  * @property lines
  * Явные строки корзины (для анонима или превью без сохранённой корзины).<br>Если null — берутся из `CartProduct` пользователя.<br>  */
  @ActiveField({
    factory: [CartPricingLineRequest, () => undefined]
  })
  lines?: null | Array<CartPricingLineRequest>


  /**
  * pointsToSpend
  * Сумма баллов к списанию, в рублях.<br>  */
  @ActiveField()
  pointsToSpend?: number
}
